export default "__VITE_ASSET__Lvx6G$hv__"